module.exports = __webpack_public_path__ + "0caa4be7f72bd9a9dcdb6dbccdcdb21d.svg";